import _ from 'lodash';
import PropTypes from 'prop-types';

import ProductItem from './ProductItem';
import formatNumericRange from '../../helpers/format_numeric_range';
import imageVariationsUrl from '../../helpers/image_variations';
import { connectLocation } from '../../location/LocationConnectors';

function formatNumericRangeValue(min, max, suffix) {
  min = min ? min.value : undefined;
  max = max ? max.value : undefined;
  return formatNumericRange(min, max, suffix);
}

// t from connectLocation
const InsulationProductListItem = ({ product, product_path, t }) => {
  const features = [];
  if (product.r_value_min || product.r_value_max) {
    features.push(
      t('product_list.item_feature.r_value_range', {
        range: formatNumericRangeValue(product.r_value_min, product.r_value_max),
      })
    );
  }
  if (product.thickness_min || product.thickness_max) {
    features.push(
      t('product_list.item_feature.thickness_range', {
        range: formatNumericRangeValue(product.thickness_min, product.thickness_max),
      })
    );
  }

  const category = _.get(product, 'categories[0].proper_name');
  const product_thumb = _.get(product, 'images.product_thumb');
  const teaser_copy = _.get(product, 'teaser_copy.value');
  const product_url = _.get(product, 'legacy_links.value', `${product_path}${product.slug}`);

  return (
    <ProductItem
      key={product.uid}
      preheading={category}
      heading={product.proper_name}
      img={product_thumb ? imageVariationsUrl(product_thumb, { screen: 'mobile', resolution: 1 }) : null}
      text={teaser_copy}
      url={product_url}
      features={features}
      track={{
        track: 'view-product',
        'product-name': product.proper_name,
      }}
    />
  );
};

InsulationProductListItem.propTypes = {
  product: PropTypes.object.isRequired,
  product_path: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default connectLocation(InsulationProductListItem);
